var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreateToken(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 1.95234C0.5 1.01216 1.26217 0.25 2.20234 0.25H13.2677C14.2079 0.25 14.9701 1.01216 14.9701 1.95234V18.609L10.8966 16.0808L7.73503 18.043L4.57349 16.0808L0.5 18.609V1.95234ZM2.32391 2.07391V15.3303L4.57349 13.9342L7.73503 15.8963L10.8966 13.9342L13.1462 15.3303V2.07391H2.32391Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.07422 5.47348C4.07422 4.96982 4.48252 4.56152 4.98617 4.56152H9.95125C10.4549 4.56152 10.8632 4.96982 10.8632 5.47348C10.8632 5.97714 10.4549 6.38544 9.95125 6.38544H4.98617C4.48252 6.38544 4.07422 5.97714 4.07422 5.47348Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.07422 9.25864C4.07422 8.75498 4.48252 8.34668 4.98617 8.34668H9.95125C10.4549 8.34668 10.8632 8.75498 10.8632 9.25864C10.8632 9.76229 10.4549 10.1706 9.95125 10.1706H4.98617C4.48252 10.1706 4.07422 9.76229 4.07422 9.25864Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateToken);
export default __webpack_public_path__ + "static/media/createToken.31dacbd81d9311b3244bde91e965fa22.svg";
export { ForwardRef as ReactComponent };